import { useEffect } from 'react';
export const UseContact = props => {
    const { fetchContactus, contactUs } = props
    useEffect(() => {
        if (contactUs.length === 0)
            fetchContactus()
    }, [fetchContactus, contactUs])
}